import { _updateData } from "@/api/esdata";
import ClearCacheBtn from "@/components/ClearCacheBtn";
import WildcardCSRPoptip from "@/components/FormItems/WildcardCSRPoptip.vue";
import Vue from "vue";
Vue.component("ClearCacheBtn", ClearCacheBtn);
Vue.component("WildcardCSRPoptip", WildcardCSRPoptip);

import { colorNames, boolToIcons, assignDefaultValue } from "@/libs/rcmTableFieldsFunction";
import { _dateFormat } from "@/libs/dateformat.js";
import { isIpDomainItem } from "@/libs/utils.js";

export const settingZoneExplain = (parentVue) => {
    return {
        description:
            "<p>Here is the place you can <strong>create, edit, and delete</strong> your domains. As a domain can includes a bunch of setting, we've split them into 3 main part, so after you create your domain in our CDN, you may also check with the <router-link to='cacherules'>Cache Rules</router-link> and <router-link to='wafrules'>Waf Rules</router-link>.</p>",
    };
};

export const groupName = (parentVue) => {
    return {
        defaultVal: parentVue.$store.state.queryGroupName,
        filter: {
            type: "string",
            defaultValue: parentVue.$store.state.queryGroupName,
        },
        filterDisabled: true,
        disabled: true,
    };
};

export const appProfileName = (parentVue) => {
    return {
        description: "<p>Select a profile for this domain.</p>",
        formRender: "FormSelect",
        defaultVal: parentVue.$route.params.appProfileName,
        filter: {
            type: "string",
            defaultValue: parentVue.$route.params.appProfileName,
        },
        filterDisabled: true,
        disabled: () => parentVue.$refs.rcmTable.formType == "createForm",
    };
};
export const keypairname = (parentVue) => {
    return {
        sectionKey: "http_https",
        vShowFieldVal: (item) => {
            return item.useSystemCert !== true ? 1 : 0;
        },
        render: (h, params) => {
            return params.row.keypairname == "self-sign" ||
                !parentVue.$can("read", "domainManagePermission", "CertsUpload")
                ? h("span", {}, params.row.keypairname)
                : h(
                      "getResourceBtn",
                      {
                          props: {
                              permissionKey: "domainManagePermission",
                              title: params.row.keypairname,
                              endPoint: "certs",
                              docId: `${params.row.groupName}-${params.row.keypairname}`,
                              groupName: params.row.groupName,
                              keyField: "keypairname",
                              managePageName: "CertsUpload",
                              renderFields: [
                                  { key: "groupName", title: parentVue.$i18n.t("domainsetting.groupName") },
                                  { key: "keypairname", title: parentVue.$i18n.t("domainsetting.keypairname") },
                                  { key: "commonName", title: parentVue.$i18n.t("certsmanage.commonName") },
                                  { key: "issuerCommonName", title: parentVue.$i18n.t("certsmanage.issuerCommonName") },
                                  { key: "sanDns", title: parentVue.$i18n.t("certsmanage.sanDns") },
                                  {
                                      key: "validityStart",
                                      title: parentVue.$i18n.t("certsmanage.validityStart"),

                                      render: (h, params) => {
                                          return h("div", _dateFormat(params.validityStart, "YYYY-MM-DD HH:mm:ss"));
                                      },
                                  },
                                  {
                                      key: "validityEnd",
                                      title: parentVue.$i18n.t("certsmanage.validityEnd"),

                                      render: (h, params) => {
                                          return h("div", _dateFormat(params.validityEnd, "YYYY-MM-DD HH:mm:ss"));
                                      },
                                  },
                                  { key: "emailAddress", title: parentVue.$i18n.t("usersmanage.emailAddress") },
                                  { key: "createBy", title: parentVue.$i18n.t("domainsetting.createBy") },
                                  {
                                      key: "createdDate",
                                      title: parentVue.$i18n.t("domainsetting.createdDate"),
                                      render: (h, params) => {
                                          return h("div", _dateFormat(params.createdDate, "YYYY-MM-DD HH:mm:ss"));
                                      },
                                  },
                                  {
                                      key: "modifiedDate",
                                      title: parentVue.$i18n.t("domainsetting.modifiedDate"),
                                      render: (h, params) => {
                                          return h("div", _dateFormat(params.modifiedDate, "YYYY-MM-DD HH:mm:ss"));
                                      },
                                  },
                                  {
                                      key: "expiredDays",
                                      title: parentVue.$i18n.t("certsmanage.expiredDays"),
                                      render: (h, params) => {
                                          return h(
                                              "p",
                                              {
                                                  style: {
                                                      color:
                                                          params.expiredDays > 30
                                                              ? colorNames.green
                                                              : params.expiredDays <= 30 && params.expiredDays > 0
                                                              ? colorNames.orange
                                                              : colorNames.red,
                                                  },
                                              },
                                              `${params.expiredDays} Days Left`
                                          );
                                      },
                                  },
                              ],
                          },
                      },
                      ""
                  );
        },
    };
};
export const isEnforceProtectWithSwitch = (parentVue) => {
    return {
        sectionKey: "advanced",
        formTypes: ["editForm", "multiEditForm"],
        align: "center",
        render: (h, params) => {
            var status = params.row.isEnforceProtect;
            var vm = parentVue.$refs.rcmTable;
            var content = params.row.isEnforceProtect
                ? vm.$i18n.t("servicegroup.disableEnforceProtectContent")
                : vm.$i18n.t("servicegroup.enableEnforceProtectContent");

            return h("i-switch", {
                props: {
                    value: status,
                    beforeChange() {
                        return new Promise((resolve) => {
                            vm.$Modal.confirm({
                                title: vm.$i18n.t("servicegroup.changeProtectModeStatusText"),
                                content,
                                width: 40,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    resolve();
                                },
                            });
                        });
                    },
                },
                on: {
                    "on-change": (value) => {
                        params.row.isEnforceProtect = !params.row.isEnforceProtect;
                        delete params.row._index;
                        delete params.row._rowKey;
                        delete params.row._checked;
                        _updateData("rcm-nginxconfigs", "index", params.row)
                            .then((result) => {
                                vm.$Notice.success({
                                    title: vm.$i18n.t("global.success"),
                                    desc: `${result.data.message}`,
                                });
                            })
                            .catch(function (error) {
                                vm.$Notice.warning({
                                    title: vm.$i18n.t("global.error"),
                                    desc: `${error}`,
                                });
                                vm.getTableData();
                            });
                    },
                },
            });
        },
    };
};
export const isEnforceProtectWithPaw = (parentVue) => {
    return {
        sectionKey: "advanced",
        formTypes: ["editForm", "multiEditForm"],
        align: "center",
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            var type = params.row.isEnforceProtect == true ? "ios-paw" : "ios-paw-outline";
            var size = "24";
            var content = params.row.isEnforceProtect
                ? vm.$i18n.t("servicegroup.disableEnforceProtectContent")
                : vm.$i18n.t("servicegroup.enableEnforceProtectContent");
            return h("icon", {
                props: {
                    type,
                    size,
                },
                on: {
                    click: (value) => {
                        vm.$Modal.confirm({
                            title: vm.$i18n.t("servicegroup.changeProtectModeStatusText"),
                            content,
                            okText: vm.$i18n.t("rcmtable.confirmText"),
                            cancelText: vm.$i18n.t("rcmtable.cancelText"),
                            onOk: () => {
                                params.row.isEnforceProtect = !params.row.isEnforceProtect;
                                delete params.row._index;
                                delete params.row._rowKey;
                                delete params.row._checked;
                                _updateData("rcm-nginxconfigs", "index", params.row)
                                    .then((result) => {
                                        vm.$Notice.success({
                                            title: vm.$i18n.t("global.success"),
                                            desc: `${result.data.message}`,
                                        });
                                    })
                                    .catch(function (error) {
                                        vm.$Notice.warning({
                                            title: vm.$i18n.t("global.error"),
                                            desc: `${error}`,
                                        });
                                        vm.getTableData();
                                    });
                            },
                        });
                    },
                },
            });
        },
    };
};

export const origins = (parentVue) => {
    return {
        withTable: false,
        formTypes: ["createForm", "editForm"],
        vShowFieldVal: (item) => {
            return item.appProfileName == "none" ? 0 : 0;
        },
    };
};

export const originscheme = (parentVue) => {
    return {
        withTable: false,
        formTypes: ["createForm", "editForm"],
        vShowFieldVal: (item) => {
            return item.appProfileName == "none" ? 0 : 0;
        },
    };
};

export const portMappingType = (parentVue) => {
    return {
        withTable: false,
        formTypes: ["createForm", "editForm"],
        vShowFieldVal: (item) => {
            return item.appProfileName == "none" ? 0 : 0;
        },
    };
};

export const originPort = (parentVue) => {
    return {
        withTable: false,
        formTypes: ["createForm", "editForm"],
        vShowFieldVal: (item) => {
            return item.portMappingType == "default" && item.useOriginPolicy == false && item.appProfileName == "none"
                ? 0
                : 0;
        },
    };
};
export const hasSystemCert = (parentVue) => {
    return {
        render: (h, params) => {
            const hasSystemCert = params.row.hasSystemCert;
            const iconType = boolToIcons({
                value: hasSystemCert,
                falseToDash: true,
            });
            const iconColor = hasSystemCert ? colorNames.green : colorNames.grey;
            const statusIcon = h("Icon", {
                props: {
                    type: iconType,
                    color: iconColor,
                    size: 24,
                },
            });

            // wildcard 域名
            const explainPoptipForWildcard = h("WildcardCSRPoptip", { props: { params: params } });
            // 一般域名
            const explainPoptip = h("DomainCertPoptip", { props: { params: params, isIpDomain: isIpDomainItem(params.row) } });
            const isWildcard = params.row.servername.startsWith("_wildcard");

            const content = isWildcard
                ? [statusIcon, explainPoptipForWildcard]
                : hasSystemCert
                ? [statusIcon]
                : [statusIcon, explainPoptip];
            return h("div", content);
        },
    };
};

export const description = (parentVue) => {
    return {
        sectionKey: "essential",
        description:
            "<p>Manage your site with your flavor, setup a description for the site will make your management easier.</p>",
        render: (h, params) => {
            return h(
                "div",
                params.row.description.split("\n").map(function (o) {
                    return h(
                        "P",
                        {
                            props: {},
                        },
                        o
                    );
                })
            );
        },
    };
};

export const action = (parentVue) => {
    return {
        width: 180,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;

            const clearCacheBtn = h("ClearCacheBtn", {
                props: {
                    shape: "circle",
                    disabled: vm.isEditBtnDisabled,
                    selectedItems: [params.row.servername],
                    groupName: params.row.groupName,
                    isAppProfile: false,
                },
            });

            const editBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: vm.isEditBtnDisabled ? "md-eye" : "md-create",
                },
                on: {
                    click: () => {
                        vm.editItem(params.row);
                    },
                },
            });

            const copyBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: "md-copy",
                    disabled: vm.isEditBtnDisabled,
                },
                on: {
                    click: () => {
                        vm.copyItem(params.row);
                    },
                },
            });

            var dropdownItems = [
                {
                    value: "delete",
                    title: vm.$t("rcmtable.deleteText"),
                    modalTitle: vm.$t("rcmtable.deleteText"),
                    modalContent: vm.$t("rcmtable.confirmDeleteText"),
                },
            ];

            const moreBtn = h(
                "Dropdown",
                {
                    props: {
                        trigger: "click",
                        placement: "right",
                        transfer: true,
                        disabled: vm.isDeleteBtnDisabled,
                    },
                    on: {
                        "on-click": (value) => {
                            var currentItem = dropdownItems.find((e) => e.value == value);
                            vm.$Modal.confirm({
                                title: currentItem.modalTitle,
                                content: currentItem.modalContent,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    console.log("click delete", params.row);
                                    var deleteItem = Object.assign({}, params.row);
                                    delete deleteItem._index;
                                    delete deleteItem._rowKey;

                                    vm.actionType = "delete";
                                    vm.updateData(vm.esIndex, "delete", deleteItem);
                                },
                            });
                        },
                    },
                },
                [
                    h("a", [
                        h("Button", {
                            props: {
                                shape: "circle",
                                icon: "md-more",
                                key: params.index,
                            },
                        }),
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list",
                        },
                        [
                            dropdownItems.map(function (item) {
                                return h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: item.value,
                                            disabled: item.disabled,
                                        },
                                    },
                                    item.title
                                );
                            }),
                        ]
                    ),
                ]
            );

            // const deleteBtn = h("Button", {
            //     props: {
            //         shape: "circle",
            //         icon: "md-trash",
            //         disabled: vm.isDeleteBtnDisabled,
            //         type: "dashed"
            //     },
            //     style: {
            //         color: "#e1e1e1"
            //     },
            //     on: {
            //         click: () => {
            //             var deleteItem = Object.assign({}, params.row);
            //             delete deleteItem._index;
            //             delete deleteItem._rowKey;

            //             vm.$Modal.confirm({
            //                 title: vm.$t("rcmtable.deleteText"),
            //                 content: vm.$t("rcmtable.confirmDeleteText"),
            //                 okText: vm.$i18n.t("rcmtable.confirmText"),
            //                 cancelText: vm.$i18n.t("rcmtable.cancelText"),
            //                 onOk: () => {
            //                     vm.actionType = "delete";
            //                     vm.updateData(vm.esIndex, "delete", deleteItem);
            //                 }
            //             });
            //         }
            //     }
            // });
            const actionDivArray = [clearCacheBtn];

            if (vm.userCanIndex) {
                actionDivArray.push(editBtn);
                actionDivArray.push(copyBtn);
            }
            actionDivArray.push(moreBtn);
            return h("div", actionDivArray);
        },
    };
};



// WEBPACK FOOTER //
// ./src/view/ProfileDomain/fields.js